"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useParameterHomeOnlineDoctor = exports.useHomeShortcuts = void 0;
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../../Firestore-Query/keyFactory");
/**
 *
 * @param firestore
 * @param type
 * @param country
 */
function useParametros(firestore, type, country) {
    const parametrosRef = (0, firestore_2.collection)(firestore, `parametros/${country}/${type}`);
    return (0, firestore_1.useFirestoreQueryData)(keyFactory_1.FirestoreKeys.Params({
        name: "Params",
        path: `parametros/${country}/${type}`
    }, [type, country]), parametrosRef);
}
/**
 *
 * @param firestore
 * @param country
 */
function useHomeShortcuts(firestore, country) {
    const homeParameter = "home"; // Lo hago así para verme obligado a tipar
    const parametrosRef = (0, firestore_2.collection)(firestore, `parametros/${country}/${homeParameter}`);
    return (0, firestore_1.useFirestoreQueryData)(keyFactory_1.FirestoreKeys.Params({
        name: "homeShorcuts",
        path: `parametros/${country}/${homeParameter}`
    }, [country]), parametrosRef, {}, {
        select: (home) => {
            return home.find((element) => element.id === "shorcuts_content");
        }
    });
}
exports.useHomeShortcuts = useHomeShortcuts;
/**
 *
 * @param firestore
 * @param country
 */
function useParameterHomeOnlineDoctor(firestore, country) {
    const homeParameter = "home"; // Lo hago así para verme obligado a tipar
    const shorcuts_content_path = "shorcuts_content";
    const shorcutsRef = (0, firestore_2.doc)(firestore, `parametros/${country}/${homeParameter}/${shorcuts_content_path}`);
    return (0, firestore_1.useFirestoreDocumentData)(keyFactory_1.FirestoreKeys.Params({
        name: "HomeOnlinedoctor",
        path: `parametros/${country}/${homeParameter}/${shorcuts_content_path}`
    }, [country]), shorcutsRef, {}, {
        select: (shorcuts_content) => {
            if (!shorcuts_content) {
                console.warn(`parametros/${country}/${homeParameter}/${shorcuts_content} doesn't exist on DB, check it please, we return false`);
                return undefined;
            }
            const onlineDoctorShorcut = shorcuts_content.shorcuts.find((shorcuts) => {
                return (shorcuts.field === "onlinedoctor");
            });
            if (!onlineDoctorShorcut) {
                console.warn(`parametros/${country}/${homeParameter}/${shorcuts_content}, there is not a shorcuts.field === onlinedoctor there, check it plase`);
                return undefined;
            }
            return onlineDoctorShorcut;
        }
    });
}
exports.useParameterHomeOnlineDoctor = useParameterHomeOnlineDoctor;
exports.default = useParametros;
